"use strict";
/*
 * Created on 01 16 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductVAT_1 = require("../model/ProductVAT");

var ProductVATConverter_1 = require("./ProductVATConverter");
/**
 * Implementation of {@link ProductVATConverter}.
 *
 * @author JMe
 */


var ProductVATConverterImpl =
/*#__PURE__*/
function (_ProductVATConverter_) {
  _inherits(ProductVATConverterImpl, _ProductVATConverter_);

  function ProductVATConverterImpl() {
    _classCallCheck(this, ProductVATConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductVATConverterImpl).apply(this, arguments));
  }

  _createClass(ProductVATConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        vatId: conversions.toDocumentReferenceId(source.vatId),
        validFrom: conversions.fromDate(source.validFrom),
        validTo: conversions.fromDate(source.validTo)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ProductVAT_1.ProductVAT(ProductVAT_1.ProductVAT.schema.id.valueOf(conversions.documentToClassId(source)), ProductVAT_1.ProductVAT.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ProductVAT_1.ProductVAT.schema.vatId.valueOf(conversions.toClassReferenceId(source.vatId)), ProductVAT_1.ProductVAT.schema.validFrom.valueOfField(source), ProductVAT_1.ProductVAT.schema.validTo.valueOfField(source));
    }
  }]);

  return ProductVATConverterImpl;
}(ProductVATConverter_1.ProductVATConverter);

exports.ProductVATConverterImpl = ProductVATConverterImpl;